<template>
    <div class="m-pager" v-if="total > 0">
        <button class="m-pager__btn" :disabled="current <= 1" @click="go(current - 1)">上一页</button>
        <div class="m-pager__info">
            <span class="m-pager__cur">{{ current }}</span>
            <span class="m-pager__sep">/</span>
            <span>{{ pageCount }}</span>
            <span class="m-pager__total">共 {{ total }} 条</span>
        </div>
        <button class="m-pager__btn" :disabled="current >= pageCount" @click="go(current + 1)">下一页</button>
    </div>
</template>

<script>
/* eslint-disable */
/**
 * m-pager —— 手机端紧凑分页
 * 事件名与 iView <Page> 保持一致，页面原有的翻页处理函数可直接复用：
 *   @on-change / @on-page-size-change
 */
export default {
    name: 'MPager',
    props: {
        total: { type: Number, default: 0 },
        current: { type: Number, default: 1 },
        pageSize: { type: Number, default: 10 },
    },
    computed: {
        pageCount() {
            return Math.max(1, Math.ceil(this.total / (this.pageSize || 10)));
        },
    },
    methods: {
        go(p) {
            if (p < 1 || p > this.pageCount || p === this.current) return;
            this.$emit('update:current', p);
            this.$emit('on-change', p);
        },
    },
};
</script>
